module.exports = __webpack_public_path__ + "static/img/49.a8b410e9.png";